import { EmailHistoryItemI } from "@/modules/email-templates-sidebar/interfaces";
import { EMAIL_TYPES } from "@/modules/email-templates-sidebar/constants";
import { EmailHistoryCard } from "@/modules/email-templates-sidebar/content/v2/sections/email-history-section/email-history-component/email-history-card";
import { EmailHistoryDate } from "@/modules/email-templates-sidebar/content/v2/sections/email-history-section/email-history-component/email-history-date";
import { useMemo } from "react";
import { DayJs } from "shared/lib/helpers/date";

export const EmailHistoryComponent = ({
  emailHistoryItem,
}: {
  emailHistoryItem: EmailHistoryItemI;
}) => {
  const { email_type, time, is_sequence, sequence_scheduled_at } =
    emailHistoryItem || {};

  const { emailType, date } = useMemo(() => {
    if (
      email_type === EMAIL_TYPES.FOLLOW_UP &&
      is_sequence &&
      sequence_scheduled_at &&
      DayJs(sequence_scheduled_at).isAfter(DayJs())
    ) {
      return {
        emailType: EMAIL_TYPES.FOLLOW_UP_SCHEDULED,
        date: sequence_scheduled_at,
      };
    }

    return { emailType: email_type, date: time };
  }, [email_type]);

  const isSentByAI = useMemo(() => {
    return [
      EMAIL_TYPES.COLD_OUTREACH,
      EMAIL_TYPES.COLD_OUTREACH_FOLLOW_UP,
      EMAIL_TYPES.FOLLOW_UP,
      EMAIL_TYPES.FOLLOW_UP_SCHEDULED,
    ].some((type) => type === emailType);
  }, [emailType]);

  return (
    <div className="flex animate-fadein">
      <EmailHistoryDate
        isSentByAI={isSentByAI}
        date={date}
        email_type={emailType}
      />
      <EmailHistoryCard isSentByAI={isSentByAI} {...emailHistoryItem} />
    </div>
  );
};
